// PatientSocialHistoryControllerApi  getPatientSocialHistory

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  GetPatientSocialHistorySocialHistoryTypeEnum,
  PatientSocialHistoryControllerApi,
} from "../../../services";
import { getConfigObject, useBaseData } from "../../../utils/utils";

interface Props {
  appointmentId?: string;
  patientUuid: string;
  socialHistoryType: GetPatientSocialHistorySocialHistoryTypeEnum;
  xTENANTID: string;
}

/**
 *
 * @author Atish Bagate
 *
 */
export const useGetAllPatientSocialHistory = ({
  appointmentId,
  patientUuid,
  socialHistoryType,
  xTENANTID,
}: Props): useBaseData<any> => {
  return useQuery({
    queryKey: [
      "all-patient-social-history",
      appointmentId,
      patientUuid,
      socialHistoryType,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!socialHistoryType && !!patientUuid,
    queryFn: async () =>
      await new PatientSocialHistoryControllerApi(getConfigObject())
        .getPatientSocialHistory(
          socialHistoryType,
          patientUuid,
          true,
          false,
          appointmentId,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
